export default "/images/dailypoints-sub.png";